import React, { useEffect, useRef, useState } from "react";
import { Table, Input, Button, Typography, Modal } from "antd";
import Highlighter from "react-highlight-words";
import { useDispatch, useSelector } from "react-redux";
// import {
//   ChangeSubjectSearchText,
//   ChangeSubjectTableData,
//   ChangeSubjectModalState,
// } from "../../../actions/adminAction";
import {
  changeSubjectSearchText,
  changeSubjectModalState,
} from "../../../reducers/admin";
import { fetchSubjectTableData } from "../../../features/adminAsync";
import "./alltopics.css";
import NewSubjectForm from "../newTopics/newtopics";
import { SearchOutlined, FileTextOutlined } from "@ant-design/icons";

const AllTopics = () => {
  const dispatch = useDispatch();
  const searchInput = useRef(null);

  const { subjectTableData, loading, SubjectsearchText, SubjectmodalOpened } =
    useSelector((state) => state.admin);
  // console.log(subjectTableData);

  useEffect(() => {
    dispatch(fetchSubjectTableData());
  }, [dispatch]);

  const openModal = (id, mode) => {
    dispatch(
      changeSubjectModalState({
        open: true,
        id,
        mode,
      })
    );
  };

  const closeModal = () => {
    dispatch(
      changeSubjectModalState({
        open: false,
        id: null,
        mode: "New Topic",
      })
    );
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    dispatch(changeSubjectSearchText(selectedKeys[0]));
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    dispatch(changeSubjectSearchText(""));
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[SubjectsearchText]}
        autoEscape
        textToHighlight={text?.toString() || ""}
      />
    ),
  });

  const nameColumnSearchProps = getColumnSearchProps("topic");

  const columns = [
    {
      title: <span style={{ color: "black" }}>Name</span>,
      dataIndex: "topic",
      key: "topic",
      width: "70%",
      ...nameColumnSearchProps,
      render: (text) => {
        const rendered = nameColumnSearchProps.render
          ? nameColumnSearchProps.render(text)
          : text;
        return <span style={{ color: "black" }}>{rendered}</span>;
      },
    },
    // Uncomment this block to enable the edit button
    // {
    //   title: "Action",
    //   key: "_id",
    //   dataIndex: "_id",
    //   render: (key) => (
    //     <span>
    //       <Button
    //         type="primary"
    //         shape="circle"
    //         icon={<EditOutlined />}
    //         onClick={() => openModal(key, "Save Changes")}
    //       />
    //     </span>
    //   ),
    // },
  ];

  return (
    <div className="admin-table-container">
      <Button
        type="primary"
        icon={<FileTextOutlined />}
        style={{ marginBottom: "10px" }}
        onClick={() => openModal(null, "Add Subject")}
      >
        Add New Subject
      </Button>

      <div className="register-trainer-form-header">
        <Typography.Title
          level={4}
          style={{ color: "#fff", textAlign: "center" }}
        >
          List of Subjects
        </Typography.Title>
      </div>

      <Table
        bordered
        columns={columns}
        dataSource={subjectTableData}
        size="medium"
        pagination={{ pageSize: 10 }}
        loading={loading}
        rowKey="_id"
        style={{ backgroundColor: "#fff", padding: "10px" }}
      />

      <Modal
        open={SubjectmodalOpened}
        title={false}
        onCancel={closeModal}
        style={{
          maxHeight: "80vh",
          overflow: "auto",
          top: "20px",
          padding: "0px",
          backgroundColor: "rgb(155,175,190)",
        }}
        destroyOnHidden={true}
        footer={null}
      >
        <NewSubjectForm />
      </Modal>
    </div>
  );
};

export default AllTopics;
